// src/components/FadeInContainer.jsx

import React from 'react';

const FadeInContainer = ({ children }) => {
  return <div className="animate-fadeIn">{children}</div>;
};

export default FadeInContainer;
